import { useState, useEffect } from 'react';
import TeamService from '../../../Team/service';

export function useGetTeams(showDisable) {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    TeamService.getAll(null, null, showDisable)
      .then((response) => {
        setTeams(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, [showDisable]);

  return {
    teams,
    setTeams
  };
}
